module.exports = __webpack_public_path__ + "img/mtt_3.4.8ef32541.png";